/* fs-pdp-bulk-packs — bulk-pack "Add" buttons. Adds qty as a one-time line, then opens
   the Ella cart-drawer in place (no redirect). The quantity-break automatic discount
   applies at checkout. */
(function () {
  'use strict';
  if (window.__fsRefillInit) return;
  window.__fsRefillInit = true;

  document.querySelectorAll('[data-refill-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant-id');
      var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
      if (!id) return;
      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = 'Adding…';

      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: Number(id), quantity: qty }] };
      if (drawer) { body.sections = 'cart-drawer'; body.sections_url = window.location.pathname; }

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          btn.textContent = '✓ Added';
          if (drawer && res.sections && res.sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
            drawer.renderContents({ sections: res.sections });
            if (typeof drawer.open === 'function') drawer.open();
          } else {
            // no drawer available — go to cart
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          }
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
        })
        .catch(function () { btn.textContent = orig; btn.disabled = false; });
    });
  });
})();
